import httpClient from '@/apis/base/httpclient';
import BudgetApi from './_buApi';

class B58KTNNAPI extends BudgetApi {
  constructor() {
    super();
  }
  controllerName = 'buB58KTNNs';

  /**
   * Hàm kiểm tra xem báo cáo đã được lập hay chưa
   * @param {*} payload
   * @returns
   */
  async checkReportExist(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/checkReportExist',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Hàm kiểm tra xem kỳ báo cáo có dữ liệu hay không
   * @param {*} payload
   * @returns
   */
  async checkDetailData(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/checkDetailData',
      data: {
        param: JSON.stringify(payload),
      },
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Get tất cả dữ liệu cán bộ
   * @returns
   */
  async getAllAccountingObject(param = {}) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/list',
      data: {
        Skip: 0,
        Take: 0,
        Sort: 'accounting_object_code',
        Columns:
          'accounting_object_code,accounting_object_name,accounting_object_id,contact_title,department_name,employee_type_name',
        Filter: '[{"Field":"is_employee","Value":true}]',
        type: 0,
        ...param,
        IsEmployee: true,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Thực hiện cập nhật tỷ lệ BH, KPCĐ
   * nthien4 01.07.2022
   * @returns
   */
  async quickUpdateRate(param) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/updateRate',
      data: {
        ...param,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu form tham số báo cáo
   * HQMINH 22.09.2022
   * @param {} param
   * @returns
   */
  async getAllTargetsByReportID(param) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getAllTargetsByReportID',
      data: {
        ...param,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy ra dữ liệu kh theo id
   * @param {*} payload
   * @returns
   */
  async getAccountDataByID(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getDataByID',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }
}

export default new B58KTNNAPI();
